// removed by extract-text-webpack-plugin
module.exports = {"scroll-to-top":"scroll-to-top___2kaBY","red":"red___Y6lfp","white":"white___3hCdu","black":"black___3s29m","dkpink":"dkpink___3tWfJ","dkred":"dkred___1aD4o"};